import { APP_EVENT_INFO, CLICKSTREAM_EVENTS, QUERY_KEYS } from '@hero/constants';
import { sendClickStreamEvent } from '@hero/services';
import { createQueryKey } from '@hero/utils';

import { queryClient } from '../queryClient';

import { getBrowserUUID, getDevice, getPage } from './utils';

export function customEvent({ page, eventType, ...data }) {
  const selectedEventData = CLICKSTREAM_EVENTS[eventType] ?? {};

  const userData = queryClient.getQueryData(createQueryKey(QUERY_KEYS.useGetUserKey));

  const eventData = {
    ...selectedEventData,
    deviceTimeCreated: new Date().toISOString(),
    page: getPage({ page }),
    device: getDevice(),
    browserUUID: getBrowserUUID(),
    brand: APP_EVENT_INFO.brand,
    user: {
      ...(userData?.email
        ? { customerType: 'R', emailId: userData.email } //! G for guest, R for registered
        : { customerType: 'G' })
      //! other field examples
      // gaClientId: "0000000000.0000000000"
      // gaSessionId: "0000000000"
    },
    ...data
  };

  sendClickStreamEvent({
    params: { brand: APP_EVENT_INFO.brand, entryBrand: APP_EVENT_INFO.brand },
    data: eventData
  });
}
